enum PinLegendDatingMethod {
  ABSOLUTE = "absolute",
  ORDINAL = "ordinal",
  RELATIVE = "relative",
}

export default PinLegendDatingMethod;
